import { ReactNode, Suspense } from 'react';

export const RouteSuspense = ({ children }: { children: ReactNode }) => (
  <Suspense
    fallback={
      <div className="flex items-center justify-center min-h-[40vh]">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[var(--color-cranberry)]" />
          <p className="mt-4 text-[var(--color-text-body)]">Chargement...</p>
        </div>
      </div>
    }
  >
    {children}
  </Suspense>
);
